import React, { useContext } from "react";
// import imagenes
import carroIcono from "../../../assets/img/camion-en-rutaT.png";
import carroIcono2 from "../../../assets/img/camion-en-rutaT2.png";
import regresoIcono from "../../../assets/img/camion-de-regresoT.png";
import CajaTp from "../../../assets/img/camion-en-revision.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUserSecret, faFileLines } from "@fortawesome/free-solid-svg-icons";
import Swal from "sweetalert2";
import { useUnidades } from "../../../hooks/test/useUnidades";
import { AuthContext } from "../../../context/authContext/authContext";
import { SocketContext } from "../../../context/SocketContext";
import { TarjetaAperturaUnidad } from "./TarjetaAperturaUnidad";
import { toast } from "react-toastify";

export const TarjetaUnidadesEnRuta = ({
  status,
  selectUnidad,
  unidad_id,
  unidad_numero,
  cedi,
  spot,
  nombre_transportadora,
  viajes,
  colorUnit,
  negocioId,
  comandos,
  tipo_unidad_id,
}) => {

  const {
    getViajeUnidad,
    getViajeAutomatico,
    putReasignarUnidad,
    getSeguimientoRegistrosSeguridad,
  } = useUnidades();

  const { user } = useContext(AuthContext);
  const { socket } = useContext(SocketContext);

  const copiarMensaje = async (id) => {
    let res = await getSeguimientoRegistrosSeguridad(id);
    if (res.ok) {

      const texto = generarMensaje(res.resumen);

      navigator.clipboard.writeText(texto)
        .then(() => {
          
          toast.success("Copiado para WhatsApp ✅");
        })
        .catch(() => {
          toast.error("Error al copiar");
        });
    } else {
      toast.error(res.msg ? res.msg :"Error al consultar los datos");
    }
    
  }

  const generarMensaje = (data) => {
    return `*Asunto: ${data.asunto}* ${data.mercancia+"," ? "Con mercancía": "Sin mercancía"}

    *Entidad:* ${data.entidad}
    *Cliente:* ${data.cliente}

    *Origen:* ${data.origen}
    *Destino:* ${data.destino}

    *Fecha y Hora:* ${data.fecha_hora}

    *Dirección:*
    ${data.direccion}

    *Ubicación:*
    ${data.link}

    *Unidad:*
    Económico: ${data.unidad.economico}
    Placas: ${data.unidad.placas}
    Serie: ${data.unidad.serie}
    Marca: ${data.unidad.marca}
    Submarca: ${data.unidad.submarca}
    Modelo: ${data.unidad.modelo}
    Color: ${data.unidad.color}

    ${data.cajas && data.cajas.length > 0 
      ? `*Cajas secas:*
    ${data.cajas.map((caja, index) => `
      ${index + 1}. Económico: ${caja.economico}
        Placas: ${caja.placas}
        Serie: ${caja.serie}
        Marca: ${data.unidad.marca}
        Submarca: ${data.unidad.submarca}
        Modelo: ${data.unidad.modelo}
        Color: ${data.unidad.color}
    `).join('')}`
      : ''
    }

    *Operador:*
    ${data.operador}

    *Tripulante:*
    ${data.tripulante}

    *Nota:*
    ${data.nota}

    *Dispositivos:*
    GPS: ${data.gps ? '✅' : '❌'}
    Botón de pánico: ${data.boton_panico ? '✅' : '❌'}
    Paro de motor: ${data.paro_motor ? '✅' : '❌'}
    AS3: ${data.as3 ? '✅' : '❌'}
    MDVR: ${data.mdvr ? '✅' : '❌'}
    Cerradura: ${data.cerradura ? '✅' : '❌'}
    `;
  }

  return (
    <div
      className="row unidad-element animated delay-01s my-3"
      title={
        status.status_id === 3 ? "Unidad en ruta" :
          status.status_id === 4 ? "Unidad de regreso a cedis" :
            status.status_id === 36 ? "Unidad asignada sin viaje iniciado" : ""
      }
      key={unidad_id}
    >
      <div
        className="col-md-2 text-center pb-3 bordersLeftRounded"
        style={{ background: "#F5F5F5" }}
      >
        <div className="contenedorCarro-salida pt-3">
          <img
            src={tipo_unidad_id === 7 ? CajaTp : status.status_id === 4 ? regresoIcono : colorUnit !== "black" ? carroIcono2 : carroIcono}
            alt=""
            className="img-fluid"
            style={{ maxWidth: "55px", background: `${colorUnit !== "black" ? colorUnit : "#f5f5f5"}` }}
          />
        </div>
      </div>

      <div
        className={`col-8 col-sm-8 text-center ${tipo_unidad_id === 7 ? "" : "cursor"}`}
        style={{ heigth: "100%", margin: "auto" }}
         onClick={async () => {
          if (tipo_unidad_id === 7) return;
          // selectUnidad(unidad_id);
          let rep = await getViajeUnidad(unidad_id);

          if (rep.viaje_activo) {
            selectUnidad(unidad_id);
          } else {
            let resp = await getViajeAutomatico(unidad_id);
            if (resp.ok) {
              if (user.roles_id === 2) {
                Swal.fire({
                  icon: 'info',
                  title: "¡Esta unidad está asignada pero aún no existe un viaje en curso!",
                  text:
                    `Operador: ${resp.viaje.operador.nombre_completo},
                    Telefono: ${resp.viaje.operador.telefono} ${resp.viaje.tripulante1 && resp.viaje.tripulante1 != null ?
                      ", Tripulante: " + resp.viaje.tripulante1.nombre_completo + ", Telefono: " + resp.viaje.tripulante1.telefono : ""}`,
                  showConfirmButton: true
                });

              } else {
                Swal.fire({
                  icon: 'info',
                  title: "¡Esta unidad está asignada pero aún no existe un viaje en curso! ¿Deseas desasignar la unidad? ",
                  text:
                    `Operador: ${resp.viaje.operador.nombre_completo},
                    Telefono: ${resp.viaje.operador.telefono} ${resp.viaje.tripulante1 && resp.viaje.tripulante1 != null ?
                      ", Tripulante: " + resp.viaje.tripulante1.nombre_completo + ", Telefono: " + resp.viaje.tripulante1.telefono : ""}`,
                  showConfirmButton: true,
                  showDenyButton: true,
                  confirmButtonText: `Si`
                }).then(async (result) => {
                  /* Read more about isConfirmed, isDenied below */
                  if (result.isConfirmed) {
                    if (cedi.flujo_id === 2 && status.status_id === 36) {
                      let r = await putReasignarUnidad(unidad_id);
                      if (r.ok) {
                        Swal.fire({
                          title: "Unidad liberada",
                          text: "La unidad ha sido liberada",
                          icon: "success",
                        });
    
                        socket.emit("traer-unidades-en-ruta_", { idNegocio: negocioId });
                        
                      } else {
                        Swal.fire({
                          title: `No se pudo liberar la unidad`,
                          text: resp.msg,
                          icon: "error",
                        });
                      }
                    }
                  }
                });
              }

            } else {
              Swal.fire({
                icon: 'info',
                title: "¡Esta unidad está asignada pero aún no existe un viaje en curso!",
                showConfirmButton: false,
                timer: 1500,
              })
              console.log("error al consultar el viaje: getViajeUnidad(unidad_id)");
            }

          }
        }}
      >

        {
          viajes.length !== 0 && viajes[0].evento_seguridads.length !== 0 ? (
            <>
              <div className="row">
                <div className="col-6">
                  <h6 className="no-margin no-padding">
                    <small>Eco:</small> <b>{unidad_numero} </b>
                    &nbsp;
                    {" "}
                    <b>
                      {cedi.nombre_cedis}{" "}
                      {spot ? (
                        <b className="text-warning mt-n4">
                          (SPOT {nombre_transportadora})
                        </b>
                      ) : (
                        ""
                      )}
                    </b>
                  </h6>
                  <h6 className="no-margin no-padding">
                    {status && (
                      <>
                        <small>Estatus: </small>
                        <b>
                          {
                            viajes.length !== 0 ?
                              viajes[0].bitacora_monitorista[0].status.nombre : status.nombre
                            // status.nombre : status.nombre
                          }
                        </b>
                      </>
                    )}
                  </h6>
                </div>
                <div
                  className="col-4"
                  style={{
                    fontSize: "0.7em",
                    fontWeight: "bold",
                    color: "red",
                    textAlign: "justify",
                    padding: "5px"
                  }}
                >
                  <FontAwesomeIcon icon={faUserSecret} /> &nbsp;
                  EVENTO DE SEGURIDAD ACTIVO
                </div>
                <div
                  className="col-2 d-flex align-items-center justify-content-center"
                  style={{
                    zIndex: 10,
                    cursor: "pointer"
                  }}
                  onClick={() => copiarMensaje(viajes[0].evento_seguridads[0].evento_seguridad_id)}
                  title="Copiar información de evento de riesgo"
                >
                  <div className="copy-icon">
                    <FontAwesomeIcon icon={faFileLines} />
                  </div>
                </div>
              </div>
            </>
          ) : (
            <>
              <h6>
                <small>Eco:</small> <b>{unidad_numero} </b>
                &nbsp;
                {" "}
                <b>
                  {cedi.nombre_cedis}{" "}
                  {spot ? (
                    <b className="text-warning mt-n4">
                      (SPOT {nombre_transportadora})
                    </b>
                  ) : (
                    ""
                  )}
                </b>
                <br />
                {status && (
                  <>
                    <small>Estatus: </small>
                    <b>
                      {
                        viajes.length !== 0 ?
                          viajes[0].bitacora_monitorista[0].status.nombre : status.nombre
                        // status.nombre : status.nombre
                      }
                    </b>
                  </>
                )}
              </h6>
            </>
          )
        }
      </div>
      <div
        className="col-2 text-right d-none d-md-block"
        style={{ heigth: "100%", margin: "auto", background: "rgb(245, 245, 245)", margin: 0, borderRadius: "0px 0.5rem 0.5rem 0px", padding: "0px", textAlign: "center" }}
      >
        <TarjetaAperturaUnidad unidad_id={unidad_id} comandos={comandos}/>
      </div>
    </div>
  );
};
